import React, { FC, memo } from 'react'

import { useFocusNodeById } from '@please/lrud'

import { TileName } from '@/components/Tiles/TileName'
import { LineTileSize } from '@/constants/common'
import { EventType } from '@/types/servicesTypes/configTypes'
import { SlideDataType } from '@/types/sliderTypes'

import { TileLogo, TileLogoWrapper, TileDescriptionWrapper } from './styles'
import { TileProgress } from './TileProgress'

export type TileDescriptionProps = {
  event?: Nullable<EventType>
  focusId: string
  tileData: SlideDataType
  isChannelSlider: boolean
  tileSize?: LineTileSize
  channelLogoImg?: string
  showName: boolean
  hasEventType: boolean
  isLiveNow: boolean
  isActive?: boolean
  isPageTileWithTitle?: boolean
}

const TileDescriptionRaw: FC<TileDescriptionProps> = ({
  event,
  focusId,
  tileData,
  isChannelSlider,
  tileSize,
  channelLogoImg,
  showName,
  hasEventType,
  isLiveNow,
  isActive,
  isPageTileWithTitle,
}) => {
  const focusNode = useFocusNodeById(focusId)

  const { title, shade } = tileData

  const start = event?.startTime
  const end = event?.endTime

  const name = event?.name || title || tileData.name

  const showLogo =
    !(isChannelSlider && !event) && channelLogoImg && hasEventType

  const isTileWithShade = shade || (isChannelSlider && event)
  const hasTileShading = Boolean(isTileWithShade && showName)

  return (
    <TileDescriptionWrapper
      $hasTileShading={hasTileShading}
      $fullWidth={!showLogo}
      $tileSize={tileSize}
      $isPageTileWithTitle={isPageTileWithTitle}
    >
      {showLogo && (
        <TileLogoWrapper>
          <TileLogo src={channelLogoImg} alt="" />
        </TileLogoWrapper>
      )}
      {showName && (
        <TileName
          className="name__item"
          text={name}
          isFocused={focusNode?.isFocused || isActive}
          isMultiline={true}
        />
      )}
      {isLiveNow && (
        <TileProgress
          start={start}
          end={end}
          isBottomPosition={isChannelSlider && !event}
        />
      )}
    </TileDescriptionWrapper>
  )
}

export const TileDescription = memo(TileDescriptionRaw)
